// removed by extract-text-webpack-plugin
module.exports = {"bgImageSmall":"index-module__bgImageSmall___3DQUI","bgImageBig":"index-module__bgImageBig___K37ZH","logo":"index-module__logo___-XFS6","bgMobile":"index-module__bgMobile___3XeVD","page-content":"index-module__page-content___jIQjq","pageContent":"index-module__page-content___jIQjq","flash-wrapper":"index-module__flash-wrapper___8k9Gc","flashWrapper":"index-module__flash-wrapper___8k9Gc"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/auth/layout/index.module.scss
// module id = 1908
// module chunks = 147